window.onload = () => {

  $('.link').mouseenter(function () {
    anime({
      targets: this,
      scale: 1.2
    });

  });
  $('.link').mouseleave(function () {
    anime({
      targets: this,
      scale: 1
    });

  });
}

